const channel = {
  rest: "f5145f46752c41e48a7cf51bd958b921",
  whatsapp: "606fdbaaf169cd7446773b7e",
  facebook: "32dc9508b1c249148a5af9e77ae0466d",
  instagram: "c28615e8d26d443cb9610b14d86d77a1",
};

export default channel;
